export interface PromotionCategory {
  _id: string
  category: string
  promotions?: string[]
  createdAt: Date
  updatedAt: Date
}

export interface PromotionContent {
  _id: string
  titleEn: string
  titleMn: string
  showPublic: boolean
  bodyTextEn: string
  bodyTextMn: string
  detailBanners?: string[]
  promotions?: string[]
  createdAt: Date
  updatedAt: Date
}

export interface PromotionDetailBanner {
  _id: string
  bannerEn?: string
  bannerMn?: string
  content?: string
  createdAt: Date
  updatedAt: Date
}

export enum PlacementOrder {
  after_first = 'after_first',
  after_second = 'after_second',
  after_third = 'after_third',
  end = 'end',
}

export interface PromotionPageBanner {
  _id: string
  bannerEn?: string
  bannerMn?: string
  buttonTextEn?: string
  buttonTextMn?: string
  deepLink?: string
  placementOrder?: PlacementOrder
  settings?: string
  createdAt: Date
  updatedAt: Date
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
  ANY = 'any',
}

export enum SubscriptionType {
  PREPAID = 'prepaid',
  POSTPAID = 'postpaid',
  DUO = 'duo',
}

export enum PromotionStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  PAUSED = 'paused',
  EXPIRED = 'expired',
}

export enum PromotionType {
  PHONE = 'phone',
  NEW_PHONE_NUMBER = 'new_phone_number',
  DATA = 'data',
  OTHER = 'other',
}

export interface PromotionSegment {
  _id: string
  name: string
  genders?: Gender[]
  minAge?: number
  maxAge?: number
  onlyMyMobiUsers?: boolean
  subscriptionType?: SubscriptionType
  inactiveDays?: number
  minDataUsage?: number
  maxDataUsage?: number
  minArpuUsage?: number
  maxArpuUsage?: number
  isActive: boolean
  ratePlans?: string[]
  promotions?: string[]
  createdAt: Date
  updatedAt: Date
}

export enum Mascot {
  mascot_1 = 'mascot_1',
  mascot_2 = 'mascot_2',
  mascot_3 = 'mascot_3',
}

export interface PromotionSettings {
  _id: string
  modalTitleEn?: string
  modalTitleMn?: string
  showManyTimes: boolean
  popUpShowTime: number
  warningMessageEn?: string
  warningMessageMn?: string
  mascot: Mascot
  themeLight?: string
  themeDark?: string
  first_type: PromotionType
  second_type: PromotionType
  third_type: PromotionType
  banners: string[]
  createdAt: Date
  updatedAt: Date
}

export interface PromotionUser extends Document {
  promotionId: string
  userId: string
  isSeen: boolean
  isTaken: boolean
  createdAt: Date
  updatedAt: Date
}

export interface Color {
  nameMn: string
  nameEn: string
  hexCode: string
}

export interface Data {
  _id: string
  imgEn?: string
  imgMn?: string
  code: string
  nameMn: string
  nameEn: string
  duration: string
  amount: string
  price: number
  discountedPrice?: number
  ratePlans?: string[]
  promotions?: string[]
  createdAt: Date
  updatedAt: Date
}

export interface Phone {
  _id: string
  imgEn?: string
  imgMn?: string
  code: string
  nameMn: string
  nameEn: string
  price: number
  discountedPrice?: number
  productLink: string
  colors?: Color[]
  promotions?: string[]
  createdAt: Date
  updatedAt: Date
}

export interface RatePlan {
  _id: string
  nameMn: string
  nameEn: string
  datas?: string[]
  segments?: string[]
  createdAt: Date
  updatedAt: Date
}

export interface Promotion {
  _id: string
  imgVerticalUrlEn?: string
  imgVerticalUrlMn?: string
  imgHorizontalUrlEn?: string
  imgHorizontalUrlMn?: string
  videoUrl?: string
  endDate: string
  titleEn: string
  titleMn: string
  descriptionEn: string
  descriptionMn: string
  type: PromotionType
  status: PromotionStatus
  deeplink?: string
  deepLinkButtonTextEn?: string
  deepLinkButtonTextMn?: string
  multiply?: number
  gift?: boolean
  isMainPromotion: boolean
  isModalPromotion: boolean
  isPublic: boolean
  datas?: string[]
  phones?: string[]
  segments?: string[]
  contents?: string[]
  categories?: string[]
  createdBy?: string
  updatedBy?: string
  createdAt: Date
  updatedAt: Date
}

export interface PromotionDataCardType {
  _id: string
  titleEn?: string
  titleMn?: string
  descriptionEn?: string
  descriptionMn?: string
  imgVerticalUrlEn?: string
  imgVerticalUrlMn?: string
  imgHorizontalUrlEn?: string
  imgHorizontalUrlMn?: string
  discount?: number
  videoUrl?: string
  endDate?: string
  isPublic?: boolean
  multiply?: number
  gift?: boolean
  isNew: boolean
  isHot: boolean
  datas?: Data[]
}

export interface PromotionPhoneCardType {
  _id: string
  titleEn?: string
  titleMn?: string
  descriptionEn?: string
  descriptionMn?: string
  imgVerticalUrlEn?: string
  imgVerticalUrlMn?: string
  imgHorizontalUrlEn?: string
  imgHorizontalUrlMn?: string
  discount?: number
  videoUrl?: string
  endDate?: string
  isPublic?: boolean
  multiply?: number
  gift?: boolean
  isNew: boolean
  isHot: boolean
  phones?: Phone[]
}

export interface PromotionNumberCardType {
  _id: string
  titleEn?: string
  titleMn?: string
  descriptionEn?: string
  descriptionMn?: string
  imgVerticalUrlEn?: string
  imgVerticalUrlMn?: string
  imgHorizontalUrlEn?: string
  imgHorizontalUrlMn?: string
  videoUrl?: string
  endDate?: string
  isPublic?: boolean
  multiply?: number
  gift?: boolean
  isNew: boolean
  isHot: boolean
}

export interface DataPromotionCarouselType {
  _id: string
  imgEn?: string
  imgMn?: string
  code: string
  nameEn: string
  nameMn: string
  duration: string
  amount: string
  discount?: number
  price: number
  discountedPrice?: number
  multiply?: number
  gift?: boolean
  isNew: boolean
  isHot: boolean
  promotionId: string
  promotions?: string[]
}
export interface PromotionDetailType {
  _id: string
  imgVerticalUrlEn?: string | null
  imgVerticalUrlMn?: string | null
  imgHorizontalUrlEn?: string | null
  imgHorizontalUrlMn?: string | null
  videoUrl?: string | null
  type: PromotionType
  titleEn: string
  titleMn: string
  multiply?: number
  gift?: boolean
  deeplink?: string
  deepLinkButtonTextEn?: string | null
  deepLinkButtonTextMn?: string | null
  descriptionEn: string
  descriptionMn: string
  endDate: string
  themeLight?: string | null
  themeDark?: string | null
  datas?: Data[]
  phones?: Phone[]
  contents?:
  | Array<{
    _id: string
    titleEn: string
    titleMn: string
    showPublic: boolean
    bodyTextEn: string
    bodyTextMn: string
    detailBanners?:
    | Array<{
      _id: string
      bannerEn?: string | null
      bannerMn?: string | null
    }>
    | null
  }>
  | null
}
export interface PhonePromotionCarouselType {
  _id: string
  imgEn?: string
  imgMn?: string
  code: string
  nameEn: string
  nameMn: string
  price: number
  discountedPrice?: number
  descriptionMn?: string
  descriptionEn?: string
  productLink: string
  colors?: Color[]
  discount?: number
  multiply?: number
  gift?: boolean
  isNew: boolean
  isHot: boolean
  promotionId: string
}
export interface PromotionTitle {
  _id: string
  titleEn: string
  titleMn: string
  descriptionEn?: string
  descriptionMn?: string
  imgVerticalUrlEn?: string
  imgVerticalUrlMn?: string
  imgHorizontalUrlEn?: string
  imgHorizontalUrlMn?: string
  endDate: string
  discount?: number
  multiply?: number
  gift?: boolean
  isNew?: boolean
  isHot?: boolean
}